import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaInstagram } from "react-icons/fa";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useVenueName } from "../hooks/useVenueName";
import { displayname, IS_DEMO } from "../App";

function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const [pages, setPages] = useState([]);
  const navRef = useRef(null);

  const { name, loading } = useVenueName();

  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (isOpen && navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  useEffect(() => {
    if (loading) return;

    const fetchPages = async () => {
      try {
        const ref = collection(db, "venues", name, "pages");
        const snap = await getDocs(ref);

        const data = snap.docs
          .map((d) => ({
            id: d.id,
            title: d.data().title || d.id,
            slug: d.data().slug?.trim() || "",
            order: d.data().order ?? 999,
          }))
          .sort((a, b) => a.order - b.order);

        setPages(data);
      } catch (error) {
        console.error("Błąd podczas ładowania stron menu:", error);
      }
    };

    fetchPages();
  }, [name, loading]);

  return (
    <header className="w-full bg-white shadow-xl fixed top-0 left-0 z-50">
      <div className="flex items-center justify-between px-4 py-3 xl:py-2 xl:px-8">
        <div className="flex items-center gap-2">
          <h1 className="text-lg font-semibold">{displayname && displayname}</h1>
        </div>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-3xl xl:hidden z-50"
          aria-label="Toggle menu"
        >
          <FaBars />
        </button>

        <nav
          ref={navRef}
          className={`fixed top-0 right-0 h-full w-2/3 bg-white p-6 pt-20 transition-transform duration-300 ease-in-out transform xl:static xl:h-auto xl:w-auto xl:p-0 xl:transform-none z-50 ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <button
            className="absolute top-4 right-4 xl:hidden text-7xl font-bold"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            &times;
          </button>

          {pages.length > 0 && (
            <ul className="flex flex-col items-center gap-6 font-medium xl:flex-row xl:gap-8 xl:items-center xl:justify-center mt-6 xl:mt-0 text-2xl xl:text-lg">
              {pages.map((page) => {
                // Jeśli IS_DEMO = false → linki tylko do /slug lub /id bez name
                let path = IS_DEMO
                  ? `/${name}` // demo: tak jak wcześniej
                  : "/"; // non-demo: prowadzi do root lub możesz ustawić fallback

                if (!IS_DEMO) {
                  if (page.slug && page.slug.trim() !== "") {
                    path = `/${page.slug.trim()}`;
                  } else if (page.id) {
                    path = `/${page.id}`;
                  }
                } else {
                  // Demo: zachowanie oryginalne z name
                  if (page.slug && page.slug.trim() !== "") {
                    if (page.slug.trim().toLowerCase() === "home") {
                      path = `/${name}`;
                    } else {
                      path = `/${name}/${page.slug.trim()}`;
                    }
                  } else if (page.id) {
                    if (page.id.toLowerCase() === "home") {
                      path = `/${name}`;
                    } else {
                      path = `/${name}/${page.id}`;
                    }
                  }
                }

                return (
                  <li key={page.id}>
                    <Link
                      to={path}
                      onClick={closeMenu}
                      className="no-underline text-black hover:text-gray-600 transition-colors"
                    >
                      {page.title}
                    </Link>
                  </li>
                );
              })}

              <li className="flex gap-4 mt-8 xl:mt-0">
                <a
                  href="https://www.instagram.com/maciejglab.pl/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-pink-600 hover:text-pink-800 text-3xl xl:text-2xl transition-colors"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
              </li>
            </ul>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Nav;
